import React, { useState, useEffect, SyntheticEvent } from "react";
import { API_BASE } from "utils/api";
import {
  Grid,
  TextField,
  Box,
  Button,
  FormControl,
  Container,
  CardContent,
} from "@mui/material";
import { RootState } from "redux/store";
import VirtualizedMultiSelect from "components/General/VirtualizedMultiSelect";

import {
  Card,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Radio,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSalesParams } from "redux/searchOptions";
import { useSelector } from "react-redux";
import { SelectChangeEvent } from "@mui/material";
const DatePickerCSS = {
  width: "80%",
  maxWidth: 50,
  marginRight: "auto",
};

export default function Searchoptions() {
  const [options, setOptions] = useState([]);
  const [storeEnabled, setStoreEnabled] = useState(true);
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const DateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const dispatcher = useDispatch();

  const newState = useSelector((state: RootState) => state.salesParams.values);
  const status = JSON.parse(JSON.stringify(newState));
  console.log(newState);
  const paymentTypes = [
    "Cash",
    "Debit",
    "Visa",
    "Master",
    "American Express",
    "Gift Card",
  ];

  const districts = ["1", "2", "5", "22", "23", "24", "25", "26"];
  const provinces = ["MB", "NB", "NL", "NS", "ON", "QC", "SK"];
  const isAllPaymentSelected =
    paymentTypes.length > 0 &&
    newState.paymentMethod.length === paymentTypes.length;
  const isAllDistrictSelected =
    districts.length > 0 && newState.districts.length === districts.length;
  const isAllProvinceSelected =
    provinces.length > 0 && newState.provinces.length === provinces.length;
  const isAllStoresSelected =
    options.length > 0 && newState.selectedStores.length === options.length;

  useEffect(() => {
    axios.get(`${API_BASE}/storesDetail`).then((res) => {
      setOptions(res.data);
    });
  }, []);

  const handleStartDateChange = (date: Date | null) => {
    status.startDate = date?.toISOString();
    dispatcher(setSalesParams(status));
  };

  const handleEndDateChange = (date: Date | null) => {
    status.endDate = date?.toISOString();
    dispatcher(setSalesParams(status));
  };

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value as string;
    setSubmitEnabled(true);
    if (value[value.length - 1] === "all") {
      status.selectedStores =
        newState.selectedStores.length === options.length ? [] : options;
      status.isAllStoresSelected = true;
      dispatcher(setSalesParams(status));
      return;
    }
    status.selectedStores = value;
    status.isAllStoresSelected = false;
    dispatcher(setSalesParams(status));
  };

  const handleDistrict = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value as string;
    setSubmitEnabled(true);
    if (value[value.length - 1] === "all") {
      status.districts =
        newState.districts.length === districts.length ? [] : districts;
      dispatcher(setSalesParams(status));
      return;
    }
    status.districts = value;
    dispatcher(setSalesParams(status));
  };

  const handleProvince = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value as string;
    if (value[value.length - 1] === "all") {
      status.provinces =
        newState.provinces.length === provinces.length ? [] : provinces;
      dispatcher(setSalesParams(status));
      return;
    }
    status.provinces = value;
    dispatcher(setSalesParams(status));
    setSubmitEnabled(true);
  };

  function handleSubmit(event: SyntheticEvent) {
    event.preventDefault();
    status.salesShow = true;
    dispatcher(setSalesParams(status));
  }

  const [salesOption, setSalesOption] = useState("Store");
  const [salesType, setSalesType] = useState("store");

  const handleSort = (event: SelectChangeEvent<unknown>) => {
    status.salesType = event.target.value;
    dispatcher(setSalesParams(status));
  };

  const handleRadio = (event: SelectChangeEvent<unknown>) => {
    setSalesOption(event.target.value as string);
    if (event.target.value == "Province") {
      status.provinceEnabled = true;
      status.districtEnabled = false;
      setStoreEnabled(false);
    }
    if (event.target.value == "District") {
      status.provinceEnabled = false;
      status.districtEnabled = true;
      setStoreEnabled(false);
    }
    if (event.target.value == "Store") {
      status.provinceEnabled = false;
      status.districtEnabled = false;
      setStoreEnabled(true);
    }
    status.selectedStores.pop();
    status.districts.pop();
    status.provinces.pop();
    dispatcher(setSalesParams(status));
  };
  return (
    <Container maxWidth={false}>
      <form noValidate onSubmit={handleSubmit}>
        <Box pt={3} pb={3}>
          <Card>
            <CardContent>
              <Box>
                <Grid container spacing={1}>
                  <Grid item md={3} xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Start Date"
                        minDate={new Date(2024, 0, 1)}
                        maxDate={new Date()}
                        value={new Date(newState.startDate)}
                        onChange={handleStartDateChange}
                      ></DatePicker>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="End Date"
                        minDate={new Date(2024, 0, 1)}
                        maxDate={new Date()}
                        value={new Date(newState.endDate)}
                        onChange={handleEndDateChange}
                      ></DatePicker>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item md={3} xs={4}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Sales Type:</FormLabel>
                      <RadioGroup
                        row
                        aria-label="salesSort"
                        name="salesSort"
                        value={salesType}
                        onChange={handleSort}
                      >
                        <FormControlLabel
                          value="store"
                          control={<Radio />}
                          label="Store"
                        />
                        <FormControlLabel
                          value="commercial"
                          control={<Radio />}
                          label="Commercial"
                        />
                        <FormControlLabel
                          value="online"
                          control={<Radio />}
                          label="Online"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={4}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Sales by:</FormLabel>
                      <RadioGroup
                        row
                        aria-label="searchOption"
                        name="searchOption"
                        value={salesOption}
                        onChange={handleRadio}
                      >
                        <FormControlLabel
                          value="Store"
                          control={<Radio />}
                          label="Store"
                        />
                        <FormControlLabel
                          value="District"
                          control={<Radio />}
                          label="District"
                        />
                        <FormControlLabel
                          value="Province"
                          control={<Radio />}
                          label="Province"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <Box pt={5}>
                      <VirtualizedMultiSelect
                        label="Stores"
                        id="allstores-mutiple-checkbox"
                        value={newState.selectedStores}
                        options={options}
                        disabled={!storeEnabled}
                        onChange={handleChange}
                        width={600}
                        showSelectAll
                        selectAllChecked={isAllStoresSelected}
                        selectAllIndeterminate={
                          newState.selectedStores.length > 0 &&
                          newState.selectedStores.length < options.length
                        }
                      />
                    </Box>
                  </Grid>
                  <Grid item md={2} xs={6}>
                    <Box pt={5}>
                      <VirtualizedMultiSelect
                        label="Districts"
                        id="districts-mutiple-checkbox"
                        value={newState.districts}
                        options={districts}
                        disabled={!newState.districtEnabled}
                        onChange={handleDistrict}
                        minWidth={160}
                        showSelectAll
                        selectAllChecked={isAllDistrictSelected}
                      />
                    </Box>
                  </Grid>
                  <Grid item md={3} xs={3}>
                    <Box pt={5}>
                      <VirtualizedMultiSelect
                        label="Province"
                        id="province-mutiple-checkbox"
                        value={newState.provinces}
                        options={provinces}
                        disabled={!newState.provinceEnabled}
                        onChange={handleProvince}
                        minWidth={160}
                        showSelectAll
                        selectAllChecked={isAllProvinceSelected}
                      />
                    </Box>
                  </Grid>

                  <Grid item md={2} xs={6} sx={{ ml: 2 }}>
                    <Box pt={5}>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={!submitEnabled}
                        sx={{ mt: 2 }}
                      >
                        Submit
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </form>
    </Container>
  );
}
